module.exports = __webpack_public_path__ + "img/renyiImg.af2c1a2e.jpg";